import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-policy-dialog',
  templateUrl: './delete-policy-dialog.component.html',
  styleUrls: ['./delete-policy-dialog.component.scss'],
  standalone: true,
  imports: [
    MatButtonModule, 
    MatDialogModule, 
    CommonModule
  ]
})
export class DeletePolicyDialogComponent {

  propertyPoliciesExist: boolean = false;
  primaryPolicySelected: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DeletePolicyDialogComponent>
  ) { }

  ngOnInit() {
    if (this.data.component === 'Policy') {
      this.propertyPoliciesExist = this.data.propertyPolicyExists;
      this.primaryPolicySelected = this.data.primaryPolicy;
    }
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
}